<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ dialogTitle() }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="form" class="form-grid">
    <div class="form-grid-row">
      <!-- Sales Rep and Comm Eligible -->
      <mat-form-field appearance="outline">
        <mat-label>Sales Rep</mat-label>
        <mat-select formControlName="salesRepId">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #salesRRepSearchInput matInput placeholder="Search Sales Rep..." (input)="filterSalesReps($event)"
              class="mat-select-search-input" aria-label="Search Sales Rep" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          @for (type of filteredSalesReps(); track type.id) {
          <mat-option [value]="type.id">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="effectiveStartDate"
          (keydown)="onKeydown($event)" (blur)="dateformat($event)">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="effectiveEndDate" (keydown)="onKeydown($event)"
          (blur)="dateformat($event)">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Percentage</mat-label>
        <input matInput type="text" (input)="roundOff($event, 100, 2, 1, 'percentage')" formControlName="percentage"
          placeholder="e.g., 20.0000">
        @if (form.get('percentage')?.hasError('max')) {
          <mat-error>Value cannot be greater than 100</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-slide-toggle formControlName="commEligible" color="primary" >
        <span class="font-medium text-gray-700 w-44 inline-block">Commission Eligible</span>
      </mat-slide-toggle>
    </div>    
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" (click)="onClose()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>